import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'

const QRScan = ({ handleClick }) => {
    return (
        <QrCodeScannerIcon
            style={{ cursor: 'pointer', fontSize: '24px' }} // Adjust style as needed
            onClick={ handleClick }
        />
    )
}

export default QRScan
